var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.dateTime}},[_vm._v("\n    "+_vm._s(_vm.date)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }